import { useEffect } from 'react';

interface UseCalendarEffectsProps {
  validateDateSearchParamHandler(): void;
}

export const useCalendarEffects = ({
  validateDateSearchParamHandler,
}: UseCalendarEffectsProps) => {
  useEffect(() => {
    validateDateSearchParamHandler();
  }, [validateDateSearchParamHandler]);
};
